import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Button from "components/common/Button";
import * as labels from "config.labels";
import React, { useEffect, useState } from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

export const AddAggregateColumnDialog = ({
  open,
  title,
  defaultName,
  existingNames,
  onSave,
  onClose,
}) => {
  const [name, setName] = useState("");
  const translateLabels = staticDataHooks.useTranslator("uiLabels");

  useEffect(() => {
    if (open) setName(defaultName ?? "");
  }, [open, defaultName]);

  const trimmed = name.trim();
  const isValid = trimmed.length > 0 && !existingNames?.has(trimmed);

  return (
    <Dialog open={open} onClose={onClose} maxWidth={"xs"} fullWidth>
      <DialogTitle>
        {translateLabels(labels.ADD_AGGREGATE_COLUMN_DIALOG_TITLE, {
          default: title ?? "",
        })}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          size={"small"}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && isValid) onSave(trimmed);
          }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color={"inherit"}>
          {translateLabels(labels.ADD_AGGREGATE_COLUMN_DIALOG_CANCEL, {
            default: "Cancel",
          })}
        </Button>
        <Button onClick={() => onSave(trimmed)} isDisabled={!isValid}>
          {translateLabels(labels.ADD_AGGREGATE_COLUMN_DIALOG_SAVE, {
            default: "Save",
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddAggregateColumnDialog;
